/* --------------------------------------------------------------------------------------
   deviceInfo.service.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export class deviceInfoService {
  /*@ngInject*/
  constructor() {
    this.lang = null;
  }
  get() {
    if (this.promise == null)
      this.promise = new Promise((resolve, reject) => {
        getDeviceInfo(
          (info) => resolve(info),
          (error) => reject(error)
        );
      });

    return this.promise;
  }
  getLanguage() {
    if (this.lang) return this.lang;

    const languageId = this.snmpService.get("1.3.6.1.2.1.43.5.1.1.10.1");
    return this.snmpService.get("1.3.6.1.2.1.43.7.1.1.2.1." + languageId);
  }
  getLanguageSync() {
    if (this.lang == null) this.lang = getLocalizationLanguage();

    return this.lang;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/deviceInfo.service.js